import { SecuriteWrapper } from "./Securite.style";
import { useEffect } from "react";
import Aos from "aos";
import Footer from "../../components/global/Footer/Footer";
import { useMediaQuery } from "react-responsive";
import Bloc from "../../components/Bloc/Bloc";
import { GiPadlock } from "react-icons/gi";
import phonelock from "../../../public/securite/phonelock.jpg";
import database from "../../../public/securite/database.png";

export default function Securite() {
  const isDesktop = useMediaQuery({ minWidth: 1024 });

  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  return (
    <SecuriteWrapper>
      <div className="headerSecuriteWrapper">
        <div className="wrap">
          <div className="gauche">
            <div className="cadre">
              <h1 className="title">
                La sécurité au coeur de notre technologie
              </h1>
              <p className="txt">
                Nous consacrons une part importante de notre temps à sécuriser
                nos outils.
              </p>
            </div>
          </div>
          {isDesktop && (
            <div className="droite">
              <GiPadlock />
            </div>
          )}
        </div>
      </div>
      <Bloc
        title={<h2 className="title">Protéger vos intérêts</h2>}
        btn="Commencer maintenant"
        img={phonelock}
        className={"phoneLock"}
        isDesktop={isDesktop}
        reverse
      >
        Les besoins de nos utilisateurs sont au centre de nos préoccupations.
        Nous ne vendons pas vos données. <br />
        <br />
        Nous sommes indépendants des banques, promoteurs ou assureurs et cela
        nous permet de vous conseiller sans conflit d'intérêt.
      </Bloc>
      <Bloc
        title={<h2 className="title">Données chiffrées</h2>}
        btn="Je simule mes investissements"
        img={database}
        isDesktop={isDesktop}
      >
        Vos données sont stockées sur des disques chiffrés. Nous utilisons les
        algorithmes de chiffrement (encryption) les plus robustes du marché.
        Rien n'est stocké sur votre téléphone / PC et l'accès à votre espace
        Easy Capital est protégé par une double authentification.
      </Bloc>
      <h3 className="title">Réponses aux questions courantes</h3>
      <div className="reponses">
        <div className="gauche">
          <h2 className="question">Etes-vous inscrit à la CNIL?</h2>
          <p className="txt">
            Oui. Les traitements informatiques réalisés sont déclarés à la CNIL
            sous le numéro A. Nous respectons strictement les obligations de la
            CNIL sur la propriété et la confidentialité des informations.
          </p>
          {isDesktop && <br />}
          <h2 className="question">
            Puis-je réaliser des virements depuis Easy Capital?
          </h2>
          <p className="txt">
            Non, Easy Capital permet uniquement de visualiser les données que
            vous aurez saisi ou agréger et de restituer des conseils sur de
            potentiels nouveaux investissements.
          </p>
        </div>
        <div className="droite">
          <h2 className="question">
            Est-ce que toute la famille voit tous les comptes ?
          </h2>
          <p className="txt">
            Non, chaque personne ne peut consulter que les comptes et actifs
            dans lequel il a une part de propriété.
          </p>
          {isDesktop && <br />}
          <h2 className="question">Que faites-vous des mes données?</h2>
          <p className="txt">
            Rien sans votre accord. En qualité de courtier, nous pouvons être
            amené à consulter des partenaires pour trouver les solutions
            adaptées et moins onéreuses mais c'est vous qui décidez lorsque nous
            réalisons cette démarche et vous savez auprès de qui, à tout
            instant.
          </p>
        </div>
      </div>
      <Footer />
    </SecuriteWrapper>
  );
}
